<template>
  <v-expansion-panel>
    <v-expansion-panel-content>
      <template v-slot:header>
        <v-container fluid>
          <v-layout align-center justify-space-between row>
            <v-flex xs8>
              <strong>{{ label }}</strong><span class="grey--text text--darken-2"> — {{ translationCount }} translations</span>
            </v-flex>
            <v-flex xs4>
              <p class="caption mb-0 mr-2 grey--text text--darken-2 text-truncate">{{ translation }}</p>
            </v-flex>
          </v-layout>
        </v-container>
      </template>

      <v-card>
        <v-card-text class="grey lighten-5">
          <v-text-field v-for="key in langs" :value="translatableValue[key]" @input="onInput(key, $event)" :label="key" :key="key" v-bind="$attrs"></v-text-field>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>

export default {
  name: 'TranslatableInput',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    label: String
  },
  data: () => ({
    langs: ['en', 'fr']
  }),
  computed: {
    translatableValue: {
      get () {
        return this.value || {}
      },
      set (v) {
        this.$emit('input', {...v})
      }

    },
    translation () {
      if (!this.translatableValue) return 'No content'
      for (const lang of this.langs) {
        if (this.translatableValue[lang]) return this.translatableValue[lang]
      }
      return 'No content'
    },
    translationCount () {
      if (!this.translatableValue) return 0
      return Object.keys(this.translatableValue).filter(key => this.translatableValue[key]).length
    }
  },
  methods: {
    onInput (key, event) {
      this.translatableValue = {
        ...this.translatableValue,
        [key]: event
      }
    }
  },
  mounted () {
    this.translatableValue = this.langs.reduce((acc, key) => {
      acc[key] = (this.value && this.value[key]) || ''
      return acc
    }, {})
  }
}
</script>

<style scoped>
.v-expansion-panel__header > .container.fluid {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/TranslatableInput.vue